import { useContext } from "react";
import CheckUpContext from "../../context/check-up";
import useCheckUpCreateMutation from "../../hooks/mutations/useCheckupCreateMutation";
import useCheckUpDeleteMutation from "../../hooks/mutations/useCheckupDeleteMutation";
import useCheckUpUpdateMutation from "../../hooks/mutations/useCheckupUpdateMutation";
import { getOptionalExamsFromAnswer, getQuestionId } from "../../utils/check-up";
import DiscardRequestModal from "../discard-request-modal";

const CheckUpDiscardRequestModal = ({
  discardModal,
  setDiscardModal,
  formWatch = {},
  lastCompletedStep,
  optionalsExams = [],
  skipUpdate = false,
}) => {
  const {
    labels,
    campaign,
    survey,
    currentRequest,
    formData,
    setCurrentRequest,
    setCurrentSectionIndex,
    setNavigation,
  } = useContext(CheckUpContext);

  const closeModal = () => setDiscardModal(false);

  const { mutateAsync: asyncDeleteRequest, isError, reset } = useCheckUpDeleteMutation(closeModal);

  const { mutateAsync: asyncUpdateRequest, isError: isUpdateError } =
    useCheckUpUpdateMutation(closeModal);

  const { mutateAsync: asyncCreateRequest, isError: isCreateError } =
    useCheckUpCreateMutation(closeModal);

  const deleteObject = {
    deleteRequest: async (currentRequest) => {
      await asyncDeleteRequest({ campaignId: campaign?.id, request: currentRequest });
    },
    isError: isError,
    reset: reset,
  };

  const updateObject = {
    updateRequest: async (currentRequest, formData, formWatch, lastCompletedStep) => {
      await asyncUpdateRequest({
        survey,
        request: currentRequest,
        formData,
        values: formWatch,
        email: formWatch[getQuestionId(survey, "mail")],
        phone: formWatch[getQuestionId(survey, "phone")],
        gender: formWatch[getQuestionId(survey, "gender")],
        dateOfBirth: formWatch[getQuestionId(survey, "birthdate")],
        workplace: formWatch[getQuestionId(survey, "workPlace")],
        birthPlace: formWatch[getQuestionId(survey, "birthPlace")],
        taxCode: formWatch[getQuestionId(survey, "fiscalCode")],
        preferredTimeSlot: formWatch[getQuestionId(survey, "availability")],
        quadro: formWatch[getQuestionId(survey, "quadro")],
        manager: formWatch[getQuestionId(survey, "manager")],
        packageSelected: currentRequest?.packageSelected?.pack?.id
          ? {
              optionalsExams: getOptionalExamsFromAnswer(
                formWatch,
                getQuestionId(survey, "optionals")
              ),
              package: currentRequest.packageSelected.pack.id,
            }
          : null,
        clinicId: formWatch[getQuestionId(survey, "center")],
        lastCompletedStep,
      });
    },
    isError: isUpdateError,
  };

  const createObject = {
    createRequest: async (formData, formWatch, lastCompletedStep) => {
      await asyncCreateRequest({
        survey,
        formData,
        values: formWatch,
        email: formWatch[getQuestionId(survey, "mail")],
        phone: formWatch[getQuestionId(survey, "phone")],
        gender: formWatch[getQuestionId(survey, "gender")],
        dateOfBirth: formWatch[getQuestionId(survey, "birthdate")],
        workplace: formWatch[getQuestionId(survey, "workPlace")],
        birthPlace: formWatch[getQuestionId(survey, "birthPlace")],
        taxCode: formWatch[getQuestionId(survey, "fiscalCode")],
        preferredTimeSlot: formWatch[getQuestionId(survey, "availability")],
        quadro: formWatch[getQuestionId(survey, "quadro")],
        manager: formWatch[getQuestionId(survey, "manager")],
        lastCompletedStep,
      });
    },
    isError: isCreateError,
  };

  const handleCloseRequest = () => {
    setCurrentRequest();
    setNavigation();
  };

  return (
    <DiscardRequestModal
      show={!!discardModal}
      closeModal={() => setDiscardModal(false)}
      formWatch={formWatch}
      lastCompletedStep={lastCompletedStep}
      labels={labels}
      survey={survey}
      currentRequest={currentRequest}
      formData={formData}
      skipUpdate={skipUpdate}
      setCurrentRequest={handleCloseRequest}
      setCurrentSectionIndex={setCurrentSectionIndex}
      deleteObject={deleteObject}
      updateObject={updateObject}
      createObject={createObject}
    />
  );
};

export default CheckUpDiscardRequestModal;
